/**
 * Resolves canonical `controlClassName` with type-specific deprecated aliases.
 * `controlClassName` wins when set; otherwise the first non-empty alias is used.
 */
export function resolveControlClassName(
  controlClassName?: string,
  ...deprecatedAliases: Array<string | undefined>
): string | undefined {
  if (controlClassName?.trim()) {
    return controlClassName;
  }
  for (const alias of deprecatedAliases) {
    if (alias?.trim()) {
      return alias;
    }
  }
  return undefined;
}
